<template>
  <div class="app-main scroll">
    <transition :name="transitionName">
      <keep-alive :include="cachedViews">
        <router-view class="content" :key="key"></router-view>
        <!-- <router-view class="content"></router-view> -->
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { hasInProgressExamGround } from '@/api/simulationGame';
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.getters.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  data() {
    return {
      transitionName: "fade-transform"
    }
  },
	mounted(){
		this.$nextTick(()=>{
			this.isCompetition();
		})
	},
	methods:{
		isCompetition(){ // 判断是否有进行中的比赛
			hasInProgressExamGround().then(res => {
				if(res.data.hasExamGround){
					const loading = this.$loading({
						text: "有进行中的比赛，正在进入比赛...",
						spinner: 'el-icon-loading',
						background: "rgba(0, 0, 0, 0.3)"
					});
					setTimeout(() => {
						loading.close();
						this.$router.push({
							name: "competition",
							query: {
								examGroundId: res.data.examGroundId
							}
						})
					}, 2000);
				}
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.app-main {
  position: relative;

  .content {
    padding: 0.8rem;
    width: calc(100% - 1.6rem);
    position: absolute;
  }
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  will-change: transform;
  transition: all 0.3s linear;
}

.fade-transform-enter {
  opacity: 0;
  transform: translate(0.2rem, 0.6rem);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translate(0, 0);
  display: none;
}
</style>
